module.exports = __webpack_public_path__ + "img/mes_2.a1d3d14d.png";